// import React, { useState } from "react";  
// import "./SignIn.css";  
// import { useNavigate } from "react-router-dom";  
// import logo from "../images/Metso-logo.png";  
// import backgroundVideo from '../Videos/mining video.mp4';  
  
// export function SignIn() {  
//   const [username, setUsername] = useState('');  
//   const [password, setPassword] = useState('');  
//   const [errorMessage, setErrorMessage] = useState('');  
//   const navigate = useNavigate();  
//   async function SubmitAction() {  
//     if (!username || !password) {  
//       setErrorMessage('Please enter both username and password');  
//       return;  
//     }  
//     try {  
//       console.log("Entering");      
//       const response = await fetch('/usrpwd', {  
//         method: 'POST',  
//         headers: {  
//           'Content-Type': 'application/json'  
//         },  
//         body: JSON.stringify({ username, password })  
//       });  
  
//       const data = await response.json();  
  
//       if (response.ok) {  
//         navigate(data.redirectUrl);  
//       } else {  
//         setErrorMessage(data.error);  
//       }  
//     } catch (error) {  
//       setErrorMessage('Error during login');
//       console.log(setErrorMessage,"Error");
//     }  
//   }  
  
//   return (  
//     <section className="signup-page">  
//       <video className="background-video" autoPlay loop muted>  
//         <source src={backgroundVideo} type="video/mp4" />  
//       </video>  
//       <div className="gradient-overlay"></div>  
//       <div className="logo-container">  
//         <img src={logo} alt="Logo" className="logo" />  
//       </div>  
//       <div className="form-container1">  
//         <h1>Sign In to Your Account</h1>  
//         {errorMessage && <p className="error-message">{errorMessage}</p>}  
//         <div className="input-container">  
//           <label htmlFor="username">Username</label>  
//           <input  
//             type="text"  
//             id="username"  
//             name="username"  
//             value={username}  
//             onChange={(e) => setUsername(e.target.value)}  
//           />  
//         </div>  
//         <div className="input-container">  
//           <label htmlFor="password">Password</label>  
//           <input  
//             type="password"  
//             id="password"  
//             name="password"  
//             value={password}  
//             onChange={(e) => setPassword(e.target.value)}  
//           />  
//         </div>  
//         <button className="signup-button" onClick={SubmitAction}>  
//           Sign In  
//         </button>  
//       </div>  
//     </section>  
//   );  
// }  



// // This is for SSO

// import React, { useEffect, useState } from "react";  
// import "./SignIn.css";  
// import { useNavigate } from "react-router-dom";  
// import logo from "../images/Metso-logo.png";  
// import { PublicClientApplication } from "@azure/msal-browser";  
// import backgroundVideo from '../Videos/mining video.mp4';  





//  const clientID = process.env.clientID
//  const tenantId = process.env.tenantId
  
// const msalConfig = {  
//   auth: {  
//     clientId: `${clientID}`,  
//     authority: `https://login.microsoftonline.com/${tenantId}`,   
//     redirectUri: process.env.redirecturi  
//   }  
// };  
  
// const msalInstance = new PublicClientApplication(msalConfig);  
  
// export function SignIn() {  
//   const navigate = useNavigate();  
//   const [isInitialized, setIsInitialized] = useState(false); 
  


//   async function SubmitAction() { 
//     const AuthURL = process.env.REACT_APP_AuthURL  
//     console.log("authurii",AuthURL)
//     const instance_running_on = process.env.REACT_APP_instance_running
//     console.log("Checking",instance_running_on)
//     if (instance_running_on === 'local') {
//       console.log("Local");
//       navigate('/broadcastmessage')
//     } else {
//       console.log("SSO")
//       window.location.href = `/auth/login`;
//     }
//   }

//   return (  
//     <section className="signup-page">  
//       <video className="background-video" autoPlay loop muted>  
//         <source src={backgroundVideo} type="video/mp4" />  
//       </video>  
//       <div className="gradient-overlay"></div>  
//       <div className="logo-container">  
//         <img src={logo} alt="Logo" className="logo" />  
//       </div>  
//       <div className="form-container1">  
//         <h1>Access Your Future with Metso</h1>  
//         {/* <p>Get Started with One Click</p>   */}
//         <button className="signup-button" onClick={SubmitAction} >  
//           Signup  
//         </button>  
//       </div>  
//     </section>  
//   );  
// }  

import React, { useState, useEffect } from "react";
import "./SignIn.css";
import { useNavigate } from "react-router-dom";
import logo from "../images/Metso-logo.png";
import backgroundVideo from '../Videos/mining video.mp4';
 
export function SignIn() {
  // State for login mode
  const [loginMode, setLoginMode] = useState('credentials'); // 'credentials' or 'sso'
 
  // State for username/password login
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
 
  const navigate = useNavigate();
 
  // Check if user is already authenticated on component mount
  useEffect(() => {
    checkAuthStatus();
  }, []);
 
  const checkAuthStatus = async () => {
    try {
      const response = await fetch('/api/auth/status', {
        method: 'GET',
        credentials: 'include'
      });
 
      const data = await response.json();
 
      if (data.authenticated) {
        // User is already logged in, redirect to broadcastmessage
        navigate('/home');
      }
    } catch (error) {
      console.error('Error checking auth status:', error);
    }
  };
 
  // Username/Password Login
  async function handleCredentialsLogin(e) {
    e.preventDefault();
 
    if (!username || !password) {
      setErrorMessage('Please enter both username and password');
      return;
    }
 
    setLoading(true);
    setErrorMessage('');
 
    try {
      const response = await fetch('/usrpwd', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ username, password })
      });
 
      const data = await response.json();
 
      if (response.ok) {
        console.log('Login successful');
        navigate(data.redirectUrl);
      } else {
        setErrorMessage(data.error || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  }
 
  // SSO Login
  function handleSSOLogin() {
    setLoading(true);
    setErrorMessage('');
   
    const instance_running_on = process.env.REACT_APP_instance_running;
   
    if (instance_running_on === 'local') {
      // For local development, redirect directly
      console.log('Local SSO - redirecting to broadcastmessage');
      navigate('/broadcastmessage');
    } else {
      // For production, redirect to Microsoft SSO
      console.log('Production SSO - redirecting to Microsoft login');
      window.location.href = '/auth/login';
    }
  }
 
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && loginMode === 'credentials') {
      handleCredentialsLogin(e);
    }
  };
 
  return (
    <section className="signup-page">
      <video className="background-video" autoPlay loop muted>
        <source src={backgroundVideo} type="video/mp4" />
      </video>
      <div className="gradient-overlay"></div>
      <div className="logo-container">
        <img src={logo} alt="Logo" className="logo" />
      </div>
      <div className="form-container1">
        <h1>Sign In to Your Account</h1>
       
        {/* Login Mode Toggle */}
        <div className="login-mode-toggle">
          <button
            type="button"
            className={`toggle-btn ${loginMode === 'credentials' ? 'active' : ''}`}
            onClick={() => {
              setLoginMode('credentials');
              setErrorMessage('');
            }}
          >
            Username & Password
          </button>
          <button
            type="button"
            className={`toggle-btn ${loginMode === 'sso' ? 'active' : ''}`}
            onClick={() => {
              setLoginMode('sso');
              setErrorMessage('');
            }}
          >
            Microsoft SSO
          </button>
        </div>
 
        {errorMessage && (
          <div className="error-message" role="alert">
            {errorMessage}
          </div>
        )}
 
        {/* Username/Password Form */}
        {loginMode === 'credentials' && (
          <form onSubmit={handleCredentialsLogin}>
            <div className="input-container">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                name="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={loading}
                autoComplete="username"
                required
              />
            </div>
            <div className="input-container">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                disabled={loading}
                autoComplete="current-password"
                required
              />
            </div>
            <button
              type="submit"
              className="signup-button"
              disabled={loading}
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>
        )}
 
        {/* SSO Login */}
        {loginMode === 'sso' && (
          <div className="sso-container">
            {/* <p className="sso-description">
              Sign in with your Microsoft organizational account
            </p> */}
            <button
              type="button"
              className="signup-button sso-button"
              onClick={handleSSOLogin}
              disabled={loading}
            >
              {loading ? 'Redirecting...' : 'Sign In with Microsoft'}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
 